import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/enter-units`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const enterUnits = {
  post: apiPathFunc(pathBase),
};
